<template>
  <div>
    <v-text-field
      v-model="formData.tanggal"
      type="date"
      label="Tanggal"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchLaporan"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title">TTPB KEMBALI PERHARI</h1>
      </div>

      <div class="mt-4">
        <table style="width: 100%" class="mb-5">
          <tr>
            <td width="20%">TANGGAL</td>
            <td width="2%">:</td>
            <td>{{ formatDate(formData.tanggal) }}</td>
          </tr>
        </table>

        <table width="100%" class="table-border">
          <thead>
            <th width="5%">TTPB</th>
            <th width="15%" class="text-center">Penerima</th>
            <th width="15%" class="text-center">Pengantar</th>
            <th width="30%" class="text-center">Kondisi</th>
            <th width="30%" class="text-center">Catatan</th>
          </thead>
          <tbody>
            <tr v-for="item in data" :key="item.id">
              <td class="text-center">{{ item.ttpb }}</td>
              <td class="text-center">{{ item.penerima }}</td>
              <td class="text-center">{{ item.pengantar }}</td>
              <td class="text-center">{{ item.kondisi_penerimaan }}</td>
              <td class="text-center">{{ item.catatan }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TTPBKembaliPerhari",
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        tanggal: ""
      },
      data: {}
    };
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchLaporan() {
      this.state.loading = true;

      await axios
        .get(`ttpb-kembali?tanggal=${this.formData.tanggal}`)
        .then(res => {
          if (!res.data) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;
          alert(err.response.data.message);
        });
    },
    formatDate(date) {
      const newDate = new Date(date);
      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
  justify-content: space-between;
}

.report .report-title {
  border-bottom: 1px solid black;
}

table {
  border-collapse: collapse;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 2px;
}
</style>
